export function toPrice(value, fallback = 0) {
  const price = parseFloat(value)
  return Number.isFinite(price) ? price : fallback
}
